// Port of api/fuel/app/classes/controller/api/monty/users/lists.php
import F from 'offline/filter/constants'
import ListsFilter from 'offline/filter/lists'
import { runFilterEndpoint } from 'offline/api/monty'

export default function(params) {
	return runFilterEndpoint(ListsFilter, params, F.OWNER_USER)
}
